import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CompanyAdminModel } from '../models/companyAdmin.model';
import { CompanyAdminService } from '../models/companyAdmin.service';
import { PersonModel } from '../../person/models/person.model';
import { PersonService } from '../../person/models/person.service';
import { CompanyModel } from '../../company/models/company.model';
import { CompanyService } from '../../company/models/company.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, IKeyValueInterface } from '../../shared/config';

@Component({
  selector: 'wego-company-admin',
  template: require('../views/companyAdmin-list.component.html'),
  providers: [CompanyAdminService, PersonService, CompanyService],

})
export class CompanyAdminListComponent implements OnInit {
  DataListModel: DataListModel;
  sub: any;
  companyMasterHashId: string;
  companyAdminList: CompanyAdminModel[];
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  isLoading: boolean;
  deleteCompanyAdminMasterHashId: string;
  resetPasswordPersonHashId: string;
  message: string;
  errorMessage: string;
  companyName: string;
  urlDefaultPage: string;
  urlCompanyList: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  validateMessage: string;
  blockUnblockMsg: string;
  blockUnblockCompanyAdminHashId: string;
  blockMsg: string;
  private popupMsg: string;
  private popupTitle: string;
  private module: string;
  private breadCrumbList: string;
  private companyList: string;

  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('addCompanyAdminModal') public addCompanyAdminModal: any;
  @ViewChild('resetPasswordModal') public resetPasswordModal: any;
  @ViewChild('inActiveModal') public inActiveModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(private companyAdminService: CompanyAdminService,
    private personService: PersonService,
    private companyService: CompanyService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService) {
  }

  get isAnyChecked(): boolean {
    if (this.companyAdminList) {
      let isCheck = this.companyAdminList.filter(x => x.isUserCompanyAdmin == false).some(x => x.isChecked == true);
      if (isCheck) {
        if (this.companyAdminList.filter(x => x.isUserCompanyAdmin == false).every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  ngOnInit() {
    this.module = this.translate.instant('LblCompanyAdmin');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.companyList = this.translate.instant('LblListPage', [this.translate.instant('LblCompany')]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlCompanyList = this.authService.GetURL(ApplicationRouteURL.URL_COMPANY_LIST);
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.companyMasterHashId = params['companyHashId'] || '';
        if (this.companyMasterHashId != '') {
          this.GetCompanyAdminList();
          this.GetCompanyDetailsByCompanyId(this.companyMasterHashId);
        }
      });
  }

  public GetCompanyDetailsByCompanyId(companyMasterHashId: string) {
    this.companyService.GetCompanyBasicDetail(companyMasterHashId)
      .subscribe(
      res => {
        this.companyName = res.data.entityName;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetCompanyAdminList() {
    this.isLoading = true;
    this.companyAdminService.GetCompanyAdminList(this.companyMasterHashId, this.DataListModel)
      .subscribe(
      res => {
        this.companyAdminList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetCompanyAdminList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetCompanyAdminList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetCompanyAdminList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetCompanyAdminList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.companyAdminService.ExportCompanyAdminList(this.companyMasterHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "CompanyAdmin" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }

  public DeleteCompanyAdmin(deleteCompanyAdminList: string[]) {
    this.isLoading = true;
    this.companyAdminService.DeleteCompanyAdmin(deleteCompanyAdminList)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetCompanyAdminList();
        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnParentCheck(isChecked: boolean) {
    this.companyAdminList.filter(x => x.isUserCompanyAdmin == false).forEach(x => x.isChecked = isChecked);
  }

  public ShowAlertModal(deleteCompanyAdminMasterHashId?: string): void {
    if (deleteCompanyAdminMasterHashId) {
      this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deleteCompanyAdminMasterHashId = deleteCompanyAdminMasterHashId;
    }
    else {
      this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.deleteCompanyAdminMasterHashId = "";
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    let deleteCompanyAdminList: any[];
    if (this.isMultipleDelete)
      deleteCompanyAdminList = this.companyAdminList.filter(x => x.isChecked).map(x => x.companyAdminHashId);
    else
      deleteCompanyAdminList.push(this.deleteCompanyAdminMasterHashId);

    this.DeleteCompanyAdmin(deleteCompanyAdminList);
    this.alertModal.hide();
  }

  // Add company admin popup
  public ShowAddCompanyAdminModal() {
    this.addCompanyAdminModal.companyMasterHashId = this.companyMasterHashId;
    this.addCompanyAdminModal.show();
  }

  public SuccessAddCompanyAdminModal($event: any) {
    this.GetCompanyAdminList();
    this.message = $event.SuccessMessage;
  }

  //Reset company admin password
  public ResetPersonPassword(personHashID: string) {
    this.personService.ResetPersonPassword(personHashID)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResetPasswordSuccess');
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblResetPasswordFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }


  public ShowResetPasswordModal(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
    this.resetPasswordModal.show();
  }

  public HideResetPasswordModal(): void {
    this.resetPasswordPersonHashId = "";
    this.resetPasswordModal.hide();
  }

  public InActiveCompanyAdmin() {
    this.isLoading = true;
    this.companyService.InActiveCompanyAdmin(this.blockUnblockCompanyAdminHashId)
      .subscribe(
      res => {
        if (res.data) {
          this.inActiveModal.hide();
          this.DataListModel.currentPage = 1;
          this.GetCompanyAdminList();
          this.popupMsg = this.translate.instant('LblRecordBlokUnBlockSuccess', [this.module, this.blockMsg]);
          this.ShowSuccessPopup();
        }
        else {
          this.isLoading = false;
          this.popupMsg = res.error;
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowInActiveModal(companyAdminHashId: string, isActive: boolean): void {
    this.blockUnblockCompanyAdminHashId = companyAdminHashId;
    this.blockMsg = isActive ? this.translate.instant('LblInactive') : this.translate.instant('LblActive');
    let roleType = this.translate.instant('LblCompanyAdmin');
    this.blockUnblockMsg = this.translate.instant('LblBlockUnblockConfirm', [this.blockMsg, roleType]);
    this.inActiveModal.show();
  }

  public HideInActiveModal(): void {
    this.inActiveModal.hide();
  }

  public SuccessInActiveModalClick(): void {
    this.InActiveCompanyAdmin();
    this.inActiveModal.hide();
  }

  public SuccessResetPasswordModalClick(): void {
    this.resetPasswordModal.hide();
    console.log(this.resetPasswordPersonHashId);
    this.ResetPersonPassword(this.resetPasswordPersonHashId);

  }

  public ResendActivationMail(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;    
    this.personService.ReSendActivationMail(personHashID)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResendActivationMailSuccess');
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblResendActivationMailFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();

  }
  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/company-admin/components/companyAdmin-list.component.ts